const message = {
  more: "More",
};

export default message;
